module.exports = __webpack_public_path__ + "AvertaStd-ExtrathinItalic.svg?60591626c958cb5b9c929646ba6ee598";